import { useState, useEffect } from 'react';
import { publicAPI } from '../../../utils/apiPublic';

export const useLocations = (addNotification) => {
  const [locations, setLocations] = useState(null);
  const [locationsLoading, setLocationsLoading] = useState(true);
  const [locationsError, setLocationsError] = useState(null);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        setLocationsLoading(true);
        setLocationsError(null);
        const response = await publicAPI.getLocations();
        const data = response.data;
        // Backend returns { success: true, data: locations }
        if (data.success && data.data) {
          // Transform the array of locations into the expected structure
          const transformedLocations = {
            SDO: [],
            SCHOOL: {
              'Elementary': [],
              'Junior High School': [],
              'Senior High School': [],
              'Integrated School': []
            }
          };

          // Process each location from the database
          data.data.forEach(location => {
            if (location.type === 'SDO') {
              transformedLocations.SDO.push(location.name);
            } else if (location.type === 'SCHOOL' && location.level) {
              if (transformedLocations.SCHOOL[location.level]) {
                transformedLocations.SCHOOL[location.level].push(location.name);
              }
            }
          });

          setLocations(transformedLocations);
        } else {
          throw new Error(data.message || 'Invalid response format');
        }
      } catch (error) {
        console.error('Error fetching locations:', error);
        setLocationsError('Failed to load locations. Please try again later.');
        setLocations(null);
      } finally {
        setLocationsLoading(false);
      }
    };

    fetchLocations();
  }, [addNotification]);

  return {
    locations,
    locationsLoading,
    locationsError
  };
}; 